import axios from 'axios';
import { useCallback } from 'react';
import { apiGateway } from 'src/config';
import { RespondentTargetEntity } from 'src/features/general/enquete-answer/store/enqueteAnswerSlice';
import { useBearerToken } from './useBearerToken';

export const useRespondentTargetApi = () => {
  const { getBearerToken } = useBearerToken();

  const getById = useCallback(
    async (respondentRequestId: string): Promise<RespondentTargetEntity[] | null> => {
      try {
        const token = await getBearerToken();
        const response = await axios.get<RespondentTargetEntity[]>(apiGateway + `/survey-answer/respondent-targets/${respondentRequestId}`, {
          headers: { Authorization: token },
          timeout: 60000,
        });
        return response.data;
      } catch {
        return null;
      }
    },
    [getBearerToken],
  );

  return {
    getById,
  };
};
